import React, { useState, useEffect } from "react";
import { $t } from '@/modules/i18n';
import Logo from '@/assets/images/logo.svg';

export default ({ message = [], children }) => {
  const [ hash, setHash ] = useState('');

  function updateHash() {
    setHash(window.location.hash)
  }

  useEffect(() => {
    window.addEventListener('hashchange', updateHash)
    return () => window.removeEventListener('hashchange', updateHash)
  }, [])

  useEffect(() => {
    setHash(window.location.hash)
  }, [])

  return (
    <nav
      className="navbar"
    >
      <div className="navbar-collapse" id="navbarNavDropdown">
        <div className="container">
        {
          children
          ? children
          : <a className="logo-group" href="/">
            <img className="logo" src={Logo} alt="Shopee Logo" />
          </a>
        }
          <ul
            className="nav"
            data-easing="easeInOutExpo"
            data-speed="1250"
            data-offset="65"
          >
            {
              message.map(item =>
                !item.hide ? <li className={`nav-item${hash === item.href ? ' active' : ''}${item.class ? ' ' + item.class : ''}`} key={item.text}>
                  <a
                    className="nav-link"
                    href={item.href}
                    target={item.target ? item.target : '_self'}
                    rel={item.target ? 'noopener noreferrer' : ''}
                  >
                    {$t(item.text)}
                  </a>
                </li> : null
              )
            }
          </ul>
        </div>
      </div>
    </nav>
  )
}
